import { createGlobalStyle } from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import agencyFont from "@/assets/fonts/agency_fb.ttf";
import Rubik from "@/assets/fonts/Rubik.ttf";
import RubikItalic from "@/assets/fonts/Rubik-Italic.ttf";
import { customScroll } from "./globalStyles";

export const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: "Agency FB";
  src: url(${agencyFont});
}
@font-face {
  font-family: "Rubik";
  src: url(${Rubik});
}
@font-face {
  font-family: "Rubik";
  font-style: italic;
  src: url(${RubikItalic});
}

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  ${customScroll}
  /* Firefox */

  :focus {
    outline: 0;
  }

  html {
    text-rendering: optimizeLegibility;
    scroll-behavior: smooth !important;
    @media (max-width: 1080px){
      font-size: 93.75%;
    }
    
    @media (max-width: 720px){
      font-size: 87.5%;  
    }
  }

  body {
    background: ${(props) => props.theme.bottomColor};
    -webkit-font-smoothing: antialiased;
  }
  
  body, input, textarea, button {
    font-family: 'Rubik', sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: ${(props) => props.theme.fontColor};
  } 

  h1,h2,h3,h4,h5,h6 {
    font-family: "Agency FB";
    letter-spacing: 0.48px;
  }

  button {
    cursor: pointer;
  }
`;
